const registry = new Map();
export function registerArchetype(a) {
    registry.set(a.id, a);
}
export function getArchetype(id) {
    const a = registry.get(id);
    if (!a)
        throw new Error(`unknown archetype: ${id}`);
    return a;
}
export function listArchetypes() {
    return [...registry.keys()];
}
